import { gql } from '@apollo/client';

export const CREATE_CONVERSATION_AUTH = gql`
  mutation CreateConversationAuth {
    createConversationAuth {
      auth {
        token
        expiresAt
      }
      userErrors {
        code
        message
      }
    }
  }
`;

export const CREATE_CONVERSATION = gql`
  mutation CreateConversation($input: CreateConversationInput!) {
    createConversation(input: $input) {
      conversation {
        id
      }
      userErrors {
        message
        code
        conversationId
      }
    }
  }
`;

export const BLOCK_DMS = gql`
  mutation BlockUserDMs($input: BlockConversationUserInput!) {
    blockConversationUser(input: $input) {
      success
      userErrors {
        code
        message
      }
    }
  }
`;

export const UNBLOCK_DMS = gql`
  mutation UnblockUserDMs($input: UnblockConversationUserInput!) {
    unblockConversationUser(input: $input) {
      success
      userErrors {
        code
        message
      }
    }
  }
`;
